import Tag from 'app/_components/Tag'
import Tile from 'app/_components/Tile'
import PreviewRichTextEditor from 'app/(main)/_components/StoryTab/PreviewRTE'
import { formatDistanceToNow } from 'date-fns'
import { de } from 'date-fns/locale'
import Link from 'next/link'
import type { ReactNode } from 'react'
import type { Descendant } from 'slate'
import { twMerge } from 'tailwind-merge'

export type StoryTileProps = {
  href: string
  updatedAt?: Date | null
  createdAt: Date
  title: string | null
  richText?: Descendant[] | null
  plainText?: string | null
  className?: string
  interactive?: ReactNode
  collections?: { id: string; name: string }[]
}

export default function StoryTile({
  interactive = true,
  className,
  updatedAt,
  createdAt,
  title,
  richText,
  plainText,
  href,
  collections,
}: StoryTileProps) {
  // A custom action (e.g. a unlink or delete button) replaces the footer.
  const hasAction = typeof interactive !== 'boolean' && Boolean(interactive)
  const footer = updatedAt ? (
    <span className="label-01">
      {formatDistanceToNow(updatedAt, { locale: de, addSuffix: true })}{' '}
      aktualisiert
    </span>
  ) : (
    <span className="label-01">
      {formatDistanceToNow(createdAt, { locale: de, addSuffix: true })} erstellt
    </span>
  )

  return (
    <div className={twMerge('relative h-full bg-white', className)}>
      <Link
        href={href}
        className="focus-visible:outline-focus block h-full focus-visible:outline-2"
      >
        <Tile
          interactive={hasAction || interactive === true || interactive == null}
          className="h-full"
          footer={hasAction ? undefined : footer}
        >
          <p className="line-clamp-4 heading-02">
            {title || (
              <span className="text-text-placeholder">Neuer Beitrag</span>
            )}
          </p>
          {collections && collections.length > 0 && (
            <div className="flex gap-1 mb-1">
              {collections.map((collection) => (
                <Tag key={collection.id}>{collection.name}</Tag>
              ))}
            </div>
          )}
          {richText && richText.length > 0 && (
            <PreviewRichTextEditor
              className="bg-transparent label-01"
              initialValue={richText}
            />
          )}
          {Boolean(plainText?.length) && (
            <pre className="line-clamp-5 body-01 text-wrap">{plainText}</pre>
          )}
          {!richText?.length && !plainText && (
            <p className="text-text-placeholder label-01">
              Dieser Beitrag ist leer...
            </p>
          )}
        </Tile>
      </Link>
      {typeof interactive !== 'boolean' && interactive && (
        <div className="absolute right-0 bottom-0">{interactive}</div>
      )}
    </div>
  )
}
